(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('selectCompany', SelectCompany)

    /** @ngInject */
    function SelectCompany($rootScope, AuthenticationService, AppCycleHelper, PATHS, DATA_EVENTS) {
        function SelectCompanyController() {
            const vm = this;

            vm.onChangeCompany = () => {
                const currentSelectedCompany = AuthenticationService.getUser().Company;

                if (vm.selectedCompany.Id && vm.selectedCompany.Id != currentSelectedCompany.Id) {
                    AuthenticationService
                        .setCompany(vm.selectedCompany.Id)
                        .then(response => {
                            $rootScope.$broadcast(DATA_EVENTS.SELECTED_COMPANY_CHANGE);

                            if (response.error)
                                AppCycleHelper.handleStateChangeError(response);
                        }, error => {
                            $rootScope.$broadcast(DATA_EVENTS.SELECTED_COMPANY_CHANGE);
                            AppCycleHelper.handleStateChangeError(error);
                        })
                }
            }

            vm.toggleSelectCompany = () => {
                $rootScope.showSelectCompany = !$rootScope.showSelectCompany;
            }

            init();

            function init() {
                const authSelectedCompany = AuthenticationService.getUser().Company;

                vm.companies = AuthenticationService.getCompanies();

                let foundCompany = vm.companies.find(company => (company.Id == authSelectedCompany.Id));

                if (foundCompany)
                    vm.selectedCompany = foundCompany;
            }
        }

        return {
            bindToController: true,
            controller: SelectCompanyController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/select-company/select-company.html`,
            scope: {
                show: '='
            }
        }
    }
}());